export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            了解屁屁影院背后的故事与理念
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/60">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              屁屁影院是一个致力于提供高清流畅免费在线观影体验的影视平台。我们汇集了海量电视剧全集、
              电影大片、动漫番剧、综艺节目等各类影视资源，涵盖国产剧、港剧、韩剧、欧美剧等多个类别。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台成立于2020年，经过多年发展，已积累超过两万部影视资源，每日保持同步更新。
              我们坚持免费模式，让每一位观众都能零门槛享受追剧乐趣。团队由一群热爱影视的技术人员和编辑组成，
              用心呈现每一部好剧。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              未来，屁屁影院将继续优化播放体验，丰富内容库，并引入更多优质资源。我们始终以用户体验为核心，
              不断迭代产品功能，致力于成为国内领先的一站式免费追剧平台。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">每日</div>
                <div className="text-xs text-foreground-500 mt-1">同步更新</div>
              </div>
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">1080P</div>
                <div className="text-xs text-foreground-500 mt-1">高清画质</div>
              </div>
              <div className="text-center p-3 rounded-lg bg-background-100">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">免费</div>
                <div className="text-xs text-foreground-500 mt-1">零门槛观看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}